import * as actionTypes from './actionTypes';
import axios from '../../axios';
import i18n from "../../i18n";
import {API} from '../../constants';


export const setCoupons = (data) => {
    return {
        type: actionTypes.SET_COUPONS,
        coupons: data
    };
};

export const setCouponsLoading = () => {
    return {
        type: actionTypes.FETCH_COUPONS_STARTING,
    };
};

export const fetchCouponsFailed = () => {
    return {
        type: actionTypes.FETCH_COUPONS_FAILED
    };
};

export const getCoupons = () => {
    return dispatch => {
        // ${moment().format('YYYY/MM')}
        dispatch(setCouponsLoading());
        axios.get(`${API}${i18n.language}/affiliate/coupon`)
            .then(response => {
                dispatch(setCoupons(response.data));
            })
            .catch(error => {
                dispatch(fetchCouponsFailed());
            });
    };
};

